import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Leaf/Text/Text.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Text';
export {styles};